import axios from "@/axios/axios";
import { Md5 } from "md5-typescript";
import { LS_PUBKEY } from "@/shared/local.storage.utils";
import { AuthDocument } from "@/interfaces/user.interfaces";

export async function getAuth(email: string, password: string, isadmin: boolean): Promise<boolean |string> {
  const data = {email, password: Md5.init(password), isadmin}
  // console.log('getAuth data=', data)
  try {
    const res = await axios.post('auth/login', data)

    localStorage.setItem(LS_PUBKEY, res.data.pk)

    return true
  } catch (e: any) {
    // console.log('catch error sur auth/login', e.response)
    return e.response.data
  }
}

export async function addAuth(email: string, isadmin: boolean): Promise<AuthDocument | null> {
  try {
    const res = await axios.post('auth/add', {email, isadmin})
    return res ? res.data : null
  } catch (e: any) {
    console.log('Error post request :', e.message)
    return null
  }
}

export async function changeEmail(oldemail: string, newemail: string): Promise<boolean> {
  try {
    const res = await axios.put('auth/email', {oldemail, newemail})
    return res ? res.status === 200 : false
  } catch (e: any) {
    // console.log('Error post request :', e.message)
    return false
  }
}

export async function setIsAdmin(authid: string, state: boolean): Promise<boolean> {
  try {
    const res = await axios.put(`auth/isadmin/${authid}/${state ? 'Y' : 'N'}`)
    return res ? res.status === 200 : false
  } catch (e) {
    // console.log('Error post request :', e.message)
    return false
  }
}

export async function resetPassword(authid: string): Promise<boolean> {
  try {
    const res = await axios.put(`auth/reset/${authid}`)
    return res ? res.status === 200 : false
  } catch (e) {
    // console.log('Error post request :', e.message)
    return false
  }
}

export async function isAuthEmpty(): Promise<boolean> {
  const res = await axios.get('auth/count')
  // console.log('isAuthEmpty res.data', res.data)
  return res && res.data && res.data.count === 0
}

export async function createAdmin(password: string) {
  const res = await axios.post('auth/admin', {password: Md5.init(password)})
  return res && res.status === 201

}
